import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { HuntService } from '../../../modules/shared/services/hunt.service';
import { catchError, of } from 'rxjs';
import { Hunt } from '@cyborg-monorepo/hunter/common';

@Injectable({ providedIn: 'root' })
export class HuntResolver implements Resolve<Hunt | null> {
  constructor(private huntService: HuntService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.params['id'];
    
    console.log('📦 HuntResolver called with ID:', id);

    if (!id) {
      console.warn('❌ No hunt ID found in route params.');
      return of(null);
    }

    return this.huntService.getHuntById(id).pipe(
      catchError(err => {
        console.error('❌ HuntResolver failed:', err);
        return of(null);
      })
    );
  }
}
